export enum FlexAlign {
  START = "Start",
  CENTER = "Center",
  END = "End",
  STRETCH = "Stretch",
  BASELINE = "Baseline",
  INITIAL = "Initial"
}

export enum FlexJustify {
  START = "Start",
  CENTER = "Center",
  END = "End",
  STRETCH = "Stretch",
  SPACE_AROUND = "SpaceAround",
  SPACE_BETWEEN = "SpaceBetween",
  INITIAL = "Initial"
}

export enum FlexGap {
  XS = 4,
  SMALL = 8,
  MEDIUM = 16,
  LARGE = 24,
  NONE = 0
}

export enum FlexDirection {
  ROW = "Row",
  COLUMN = "Column"
}
